// extracted by mini-css-extract-plugin
export default {"container":"main_container__ywGNG"};